export default {
  cn: {
    roleModel: {
      roleInfo: '角色信息',
      role: '角色',
      roleName: '角色名称',
      description: '描述',
      setFunc: '设置功能',
      setReadOnly: '设置只读',
      existingFuncList: '已有功能列表',
      selectedFuncList: '已选中的功能列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '请输入',
      pleaseSelect: '请选择',
      noEdit: '尚未修改，无须保存',
      errTips: '请正确填写信息',
      btnBack: '返回',
    }
  },
  hk: {
    roleModel: {
      roleInfo: '角色信息',
      role: '角色',
      roleName: '角色名稱',
      description: '描述',
      setFunc: '設置功能',
      setReadOnly: '設置只讀',
      existingFuncList: '已有功能列表',
      selectedFuncList: '已選中的功能列表',
      saveBtn: '保存',
      success: '保存成功',
      pleaseEnter: '請輸入',
      pleaseSelect: '請選擇', 
      noEdit: '尚未修改，無須保存',
      errTips: '請正確填寫信息',
      btnBack: '返回',
    }
  },
  en: {
    roleModel: {
      roleInfo: 'Role Info',
      role: 'Role',
      roleName: 'Role Name',
      description: 'Description',
      setFunc: 'Set Function',
      setReadOnly: 'Set Read Only',
      existingFuncList: 'Existing Function List',
      selectedFuncList: 'Selected Function List',
      saveBtn: 'SAVE',
      success: 'Successful',
      pleaseEnter: 'Please Enter',
      pleaseSelect: 'Please Select',
      noEdit: 'Not yet modified, no need to save',
      errTips: 'Please fill in the information correctly',
      btnBack: 'Back',
    }
  },
}


// WEBPACK FOOTER //
// ./src/language/roleModel.js